import DeepDiff from 'deep-diff'
import StoreUtil from '@/store/utils'
import FlexiquoteModuleService from './flexiquoteModuleService'
import SuperadminFlexiquoteModuleRoutes from './route-types'

const tag = 'flexiquotemodule'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: [],
  saving: false,
  hasError: false
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: (state) => state.snapshots,
  baseSnapshot: (state) => state.snapshots[state.baseIndex],
  currentSnapshot: (state) => state.snapshots[state.currentIndex],
  snapshotDiff: (state) => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  },
  hasError: (state) => state.hasError,
  saving: (state) => state.saving
}

const actions = {
  async getStoreItem({ commit }, id) {
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity || (entity && !entity.isNew)) {
      const data = await FlexiquoteModuleService.getEntity(id)
      if (data) {
        entity = data
      }
    }
    StoreUtil.setStorage(entity.flexiQuoteModuleId, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async addStoreItem({ commit }) {
    const entity = await FlexiquoteModuleService.getNewEntity()
    entity.isNew = true
    StoreUtil.setStorage(entity.flexiQuoteModuleId, tag, entity)
    commit('saveInitialSnapshots', entity)
    return StoreUtil.routeToDetail(SuperadminFlexiquoteModuleRoutes.FlexiquoteModuleView.path, entity.flexiQuoteModuleId, entity.isNew)
  },
  clearSnapshots({ commit }, id) {
    if (id) {
      StoreUtil.removeStorage(id, tag)
    }
    commit('clearSnapshots')
  },
  saveInitialSnapshots({ commit }, entity) {
    commit('saveInitialSnapshots', entity)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  }
}

const mutations = {
  clearSnapshots(state) {
    state.baseIndex = 0
    state.currentIndex = 0
    state.snapshots = []
  },
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

